import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import MobileFooterNav from './components/MobileFooterNav';
import SubscriptionCTA from './components/SubscriptionCTA';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import HomePage from './pages/HomePage';
import SermonsPage from './pages/SermonsPage';
import BibleStudiesPage from './pages/BibleStudiesPage';
import PrayerPage from './pages/PrayerPage';
import BlogPage from './pages/BlogPage';
import OutreachPage from './pages/OutreachPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import StatementOfFaithPage from './pages/StatementOfFaithPage';
import SubscribePage from './pages/SubscribePage';
import SubscribeThankYouPage from './pages/SubscribeThankYouPage';
import AdminPage from './pages/AdminPage';
import BlogPostPage from './pages/BlogPostPage';
import EventsPage from './pages/EventsPage';
import EventDetailsPage from './pages/EventDetailsPage';
import DBUEventPage from './pages/DBUEventPage';
import ModifyRSVPPage from './pages/ModifyRSVPPage';
import EventRedirect from './components/EventRedirect';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Header />
            <main className="min-h-screen">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/sermons" element={<SermonsPage />} />
                <Route path="/bible-studies" element={<BibleStudiesPage />} />
                <Route path="/prayer" element={<PrayerPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/events" element={<EventsPage />} />
                <Route path="/events/:eventId" element={<EventDetailsPage />} />
                <Route path="/events/:eventId/modify" element={<ModifyRSVPPage />} />
                <Route path="/modify-rsvp" element={<ModifyRSVPPage />} />
                <Route path="/outreach" element={<OutreachPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/statement-of-faith" element={<StatementOfFaithPage />} />
                <Route path="/subscribe" element={<SubscribePage />} />
                <Route path="/subscribe/thank-you" element={<SubscribeThankYouPage />} />
                
                {/* Dedicated DBU Event Page */}
                <Route path="/DBU" element={<DBUEventPage />} />
                
                {/* Other short URL redirects for December 11th DBU event */}
                <Route path="/dbu" element={<EventRedirect eventId="9a407f95-8675-4b00-8779-0a9a1d055cd8" />} />
                <Route path="/worship-night" element={<EventRedirect eventId="9a407f95-8675-4b00-8779-0a9a1d055cd8" />} />
                <Route path="/dec11" element={<EventRedirect eventId="9a407f95-8675-4b00-8779-0a9a1d055cd8" />} />
                
                <Route path="/admin" element={
                  <ProtectedRoute>
                    <AdminPage />
                  </ProtectedRoute>
                } />
              </Routes>
            </main>
            <Footer />
            <ScrollToTop />
            <MobileFooterNav />
            <SubscriptionCTA />
          </div>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;